import createAction from '@clearscore/helpers.create-action';

export const SET_USER_ALREADY_REGISTERED = 'CS/SET_USER_ALREADY_REGISTERED';

// used to display an alert when users goes to /login/already-registered
export const setUserAlreadyRegistered = () => createAction(SET_USER_ALREADY_REGISTERED);
